import {
  Avatar,
  Button,
  Card,
  Col,
  Image,
  Layout,
  message,
  Row,
  Tag,
  Typography,
} from 'antd';
import React from 'react';
import {
  IoLinkOutline,
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoTwitter,
  IoLogoWhatsapp,
  IoLogoYoutube,
  IoMailOutline,
} from 'react-icons/io5';
import { Link, Outlet } from 'react-router-dom';
import logo from '../../assets/img/logo/jurisvip-all-branco-transparente-menor.png';
import { getToken, POST_API, POST_CATCH } from '../../services/api';

class WebPerfil extends React.Component {
  state = {
    _params: window.location.href.split('/'),
    select: 'sobre',
    profile: null,
    _equipe_total: 0,
    _cliente_total: 0,
  };

  componentDidMount = () => {
    this.onSelect(this.state._params[5] ? this.state._params[5] : 'sobre');
    this.onView();
    this.onRenderDataEquipe();
    this.onRenderDataCliente();
  };

  onView = async () => {
    await POST_API('/credential/search.php', {
      token: getToken(),
      filter: JSON.stringify({ ID: this.state._params[4] }),
      type: 'view',
    })
      .then((rs) => rs.json())
      .then((res) => {
        this.setState({ profile: res.data, _screen: false });
      })
      .catch(() => POST_CATCH());
  };

  onRenderDataEquipe = () => {
    setTimeout(() => {
      POST_API('/team/search.php', {
        token: getToken(),
        filter: JSON.stringify({ CREDENTIAL_ID: this.state._params[4] }),
        type: 'list',
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            this.setState({
              _equipe_total: res.summary.QTDE,
            });
          } else {
            message.error({ content: res.msg, key: 'screen' });
          }
        })
        .catch(() => POST_CATCH());
    }, 500);
  };

  onRenderDataCliente = () => {
    setTimeout(() => {
      POST_API('/client_team/search.php', {
        token: getToken(),
        filter: JSON.stringify({ CREDENTIAL_ID: this.state._params[4] }),
        type: 'list',
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            this.setState({
              _cliente_total: res.summary.QTDE,
            });
          } else {
            message.error({ content: res.msg, key: 'screen' });
          }
        })
        .catch(() => POST_CATCH());
    }, 500);
  };

  onSelect = (page) => {
    this.setState({ select: page });
  };

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: ignora
  render = () => {
    return (
      <Layout.Content className="web-body">
        <Layout.Content className="web-content web-perfil" id="web-content">
          <Row className="perfil-content">
            <Col span={24}>
              <Card
                actions={[
                  <Row gutter={[8, 8]} justify={'center'} key={'row'}>
                    <Col>
                      <Link to="sobre">
                        <Button
                          className={
                            this.state.select === 'sobre'
                              ? 'btn-link-perfil active'
                              : 'btn-link-perfil'
                          }
                          onClick={() => this.onSelect('sobre')}
                          type="link"
                        >
                          SOBRE
                        </Button>
                      </Link>
                    </Col>
                    {this.state._equipe_total > 0 ? (
                      <Col>
                        <Link to="nossaequipe">
                          <Button
                            className={
                              this.state.select === 'nossaequipe'
                                ? 'btn-link-perfil active'
                                : 'btn-link-perfil'
                            }
                            onClick={() => this.onSelect('nossaequipe')}
                            type="link"
                          >
                            NOSSA EQUIPE
                          </Button>
                        </Link>
                      </Col>
                    ) : null}
                    <Col>
                      <Link to="contatos">
                        <Button
                          className={
                            this.state.select === 'contatos'
                              ? 'btn-link-perfil active'
                              : 'btn-link-perfil'
                          }
                          onClick={() => this.onSelect('contatos')}
                          type="link"
                        >
                          CONTATOS
                        </Button>
                      </Link>
                    </Col>
                    {this.state._equipe_total > 0 ? (
                      <Col>
                        <Link to="clientes">
                          <Button
                            className={
                              this.state.select === 'clientes'
                                ? 'btn-link-perfil active'
                                : 'btn-link-perfil'
                            }
                            onClick={() => this.onSelect('clientes')}
                            type="link"
                          >
                            CLIENTES
                          </Button>
                        </Link>
                      </Col>
                    ) : null}
                    <Col>
                      <Link to="galeria">
                        <Button
                          className={
                            this.state.select === 'galeria'
                              ? 'btn-link-perfil active'
                              : 'btn-link-perfil'
                          }
                          onClick={() => this.onSelect('galeria')}
                          type="link"
                        >
                          GALERIA
                        </Button>
                      </Link>
                    </Col>
                  </Row>,
                ]}
                cover={
                  <Image
                    className="banner-profile"
                    height={300}
                    preview={false}
                    src={this.state.profile?.BANNER}
                  />
                }
              >
                <center>
                  <Avatar
                    className="perfil-avatar"
                    size={200}
                    src={this.state.profile?.INTER_AVATAR}
                  />
                </center>
                <center>
                  <Typography className="perfil-title">
                    {this.state.profile?.NAME}
                  </Typography>
                </center>
                <center>
                  <Row justify={'center'}>
                    {this.state.profile?.SPECIALITY_ITEMS.map((v) => (
                      <Col key={v.ID}>
                        <Tag>{v.SPECIALTY_NAME}</Tag>
                      </Col>
                    ))}
                  </Row>
                </center>
                <Row
                  gutter={[8, 8]}
                  justify={'center'}
                  style={{ marginTop: 10 }}
                >
                  {this.state.profile?.EMAIL ? (
                    <Col>
                      <a
                        href={`mailto:${this.state.profile?.EMAIL}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoMailOutline size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.WHATSAPP ? (
                    <Col>
                      <a
                        href={`https://web.whatsapp.com/send?phone=${this.state.profile?.WHATSAPP}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLogoWhatsapp size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.FACEBOOK ? (
                    <Col>
                      <a
                        href={`${this.state.profile?.FACEBOOK}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLogoFacebook size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.INSTAGRAM ? (
                    <Col>
                      <a
                        href={`${this.state.profile?.INSTAGRAM}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLogoInstagram size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.TWITTER ? (
                    <Col>
                      <a
                        href={`${this.state.profile?.TWITTER}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLogoTwitter size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.LINKEDIN ? (
                    <Col>
                      <a
                        href={`${this.state.profile?.LINKEDIN}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLogoLinkedin size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.YOUTUBE ? (
                    <Col>
                      <a
                        href={`${this.state.profile?.YOUTUBE}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLogoYoutube size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                  {this.state.profile?.SITE ? (
                    <Col>
                      <a
                        href={`${this.state.profile?.SITE}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Button
                          className="btn-logos-perfil"
                          shape="circle"
                          type="default"
                        >
                          <IoLinkOutline size={20} />
                        </Button>
                      </a>
                    </Col>
                  ) : null}
                </Row>
              </Card>
            </Col>
            <Col span={24}>
              <Outlet />
            </Col>
          </Row>
          <Row align={'middle'} style={{ marginTop: 40 }}>
            <Col className="home-col-red" span={24}>
              <Row className="home-row-page-footer">
                <Col className="home-row-col" span={24}>
                  <center>
                    <Image
                      className="perfil-footer"
                      preview={false}
                      src={logo}
                    />
                  </center>
                </Col>
              </Row>
            </Col>
          </Row>
        </Layout.Content>
      </Layout.Content>
    );
  };
}

export default WebPerfil;
